var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionCmpContainer bounce"},[_c('questionCmp',{attrs:{"qNumber":_vm.questionNumber,"qDetails":_vm.questionDetails[_vm.questionNumber]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }